import React from "react";
import { Popover, Box, TextField, Button, Typography } from "@mui/material";
import { addCreatorRate } from "../live-campaign-repository";
import { LoadingButton } from '@mui/lab';

const PricePopover = ({ anchorEl, handleClose, campaignId, paymentRequest, handleCreatorRateSave, setRateAdded, setPaymentRequest }) => {
  const [loading, setLoading] = React.useState(false);
  const open = Boolean(anchorEl);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await addCreatorRate(campaignId, paymentRequest, setRateAdded, setPaymentRequest);
      handleClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <Box
        sx={{
          width: 400,
          p: 3,
          bgcolor: "background.paper",
          boxShadow: 3,
          borderRadius: 2,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            mb: 1,
            color: "#464646",
            fontWeight: 600,
            fontSize: "20px",
            fontFamily: "sans-serif",
          }}
        >
          Set Creator Price
        </Typography>

        <Typography
          variant="body2"
          sx={{
            mb: 2,
            color: "#8A8989",
            fontWeight: 400,
            fontSize: "14px",
            fontFamily: "sans-serif",
          }}
        >
          Enter the price for this creator
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography sx={{ color: "#9333EA", fontWeight: 400, fontSize: "20px" }}>
            ₹
          </Typography>
          <TextField
            fullWidth
            type="number"
            value={paymentRequest.price}
            name="price"
            onChange={(e) => handleCreatorRateSave("price", e.target.value)}
            placeholder="Enter Price"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderColor: "#464646",
                borderWidth: "2px",
                "&:hover fieldset": { borderColor: "#464646" },
                "&.Mui-focused fieldset": { borderColor: "#464646" },
              },
            }}
          />
        </Box>

        <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <Button
            variant="outlined"
            sx={{
              color: "#464646",
              borderColor: "#CECECE",
              "&:hover": { borderColor: "#8A8989", backgroundColor: "#F2F2F2" },
            }}
            onClick={handleClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <LoadingButton
            loading={loading}
            loadingPosition="center"
            variant="contained"
            sx={{
              backgroundColor: "#65308F",
              color: "#fff",
              "&:hover": { backgroundColor: "#4A1A6D" },
            }}
            onClick={handleSubmit}
            disabled={loading}
          >
            {!loading && "Save"}
          </LoadingButton>
        </Box>
      </Box>
    </Popover>
  );
};

export default PricePopover;
